
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Box, Divider, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";

const ArcBannerWithScore = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label, Proportion } = ComponentProperties
    const DataReportData = props.DataReportData
    // KeyToUse will be an array
    const ArcSumOfValues = _.sumBy(DataReportData, item => Number(item[KeyToUse]))

    const ArcFinalValue = Math.trunc(ArcSumOfValues / (DataReportData && DataReportData.length || 1))

    const labelCenter = {
        id: "labelCenter",
        beforeDraw: (chart, args, options) => {
            if (!Array.isArray(options.labels)) {
                return console.error('"options.lables" must be array', options.lables);
            }

            const {
                ctx,
                chartArea: { width, height }
            } = chart;
            const context = ctx.canvas.getContext("2d");
            context.save();

            const labels = options.labels.slice();
            const totalFontSize = labels.reduce((x, y, index) => {
                let prevSize = x[index - 1] || 0;
                x.push(prevSize + y.font.size);
                return x;
            }, []);
            labels.forEach((label, index) => {
                let textPosition = totalFontSize[index] - label.font.size + 10;
                const values = {
                    text: label.text || "?",
                    font: {
                        size: label.font.size || 30,
                        family: label.font.family || "sans-serif",
                        color: label.font.color || "black",
                        style: label.font.style || "normal",
                        unit: label.font.unit || "px"
                    }
                };
                switch (values.font.unit) {
                    case "em":
                        values.font.size = label.font.size * 0.05;
                        textPosition *= 0.9;
                        break;
                    default:
                        break;
                }

                context.font = `${values.font.style} ${values.font.size}${values.font.unit} ${values.font.family}`;
                context.textAlign = "center";
                context.fillStyle = values.font.color;
                context.fillText(values.text, width / 2, height / 2 + textPosition);
            });
            context.restore();
        }
    };

    const graphcolors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
    const GetColor = (score) => {

        const vg = parseInt(score <= 39 ? 3 : score <= 69 ? 2 : score <= 100 ? 1 : 0)
        return graphcolors[vg]
    }

    const Color = GetColor(ArcFinalValue)
    const data = {
        datasets: [
            {

                data: [ArcFinalValue, MaxValue - ArcFinalValue],
                backgroundColor: [
                    Color,
                    Color + "40"
                ],
                borderColor: [
                    'rgba(255, 99, 132, 0)',
                    'rgba(54, 162, 235, 0)',
                ],
                borderWidth: 0,
            },
        ],
    }
    const options = {
        responsive: false,
        cutout: '70%',
        maintainAspectRatio: false,
        animation: {
            animateRotate: true,
            render: false,
        },
        events: [],
        tooltips: {
            enabled: true
        },
        plugins: {
            legend: {
                display: false
            },
            labelCenter: {
                labels: [
                    {
                        text: ArcFinalValue,
                        font: {
                            size: 1.5,
                            unit: "rem",
                            color: 'black',
                            style: "bold"
                        }
                    }
                ]
            }

        }

    }

    const plugins = [labelCenter]

    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
            <Grid item xs={2}>
                <Doughnut data={data} options={options} plugins={plugins} height="75px" width={"100%"} />
            </Grid>
            <Grid item xs={10}>
                <Typography variant="h3" align="left">{Label}</Typography>
            </Grid>
        </Grid>
    )
}

export default ArcBannerWithScore